var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-wrapper page"},[_c('h1',[_vm._v("Ой! Страница не найдена! :(")])])
}]

export { render, staticRenderFns }